export default "__VITE_ASSET__9b27be57__"